import React from 'react'
import Wrapper from './Wrapper'
import { Button } from 'components/base'
import serverError from 'assets/images/serverError.svg'
import * as Icons from 'components/Utils/Icons'

const image = (
  <img src={serverError} alt="server-error" style={{ width: 564 }} />
)

class UnhandledError extends React.Component {
  renderRefreshButton = () => (
    <Button.Primary
      className="margin-left-large font-weight-bold"
      onClick={() => window.location.reload()}
    >
      <div className="flexbox flexbox-align-center">
        <div>
          <Icons.RedoIcon size={16} />
        </div>
        <div className="margin-left-normal"> Refresh</div>
      </div>
    </Button.Primary>
  )

  render() {
    return (
      <Wrapper
        image={image}
        goBackButton={
          <div className="flexbox">{this.renderRefreshButton()}</div>
        }
        title={'Uh-oh'}
        subtitle={`Well, this is unexpected...`}
      >
        <div className="font-weight-medium shade-10 margin-bottom-large">
          Error 500
        </div>
        <div>
          <span>
            An error has occured on our side, and we are working to fix the
            problem!
          </span>
          <br />
          <span>We'll be up and running shortly, try to come back later.</span>
        </div>
      </Wrapper>
    )
  }
}

export default UnhandledError
